import { PercentPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { QuestionnaireService } from '../../shared/services/questionnaire.service';

@Component({
  selector: 'md-cash-allocation-option',
  template: require('./cash-allocation-option.component.html'),
  styles: [require('./cash-allocation-option.component.scss')]
})
export class CashAllocationOptionComponent {
  @Input() option;
  tagline;
  name;
  advisoryFee;
  heldInCash;
  description;
  advisoryText;
  heldText;

  constructor(questionnaire: QuestionnaireService, percentPipe: PercentPipe) {
    this.questionnaire = questionnaire;
    this.percentPipe = percentPipe;
  }

  ngOnInit() {
    this.tagline = this.option.tagline;
    this.name = this.option.name;
    this.advisoryFee = this.option.advisoryFee;
    this.heldInCash = this.option.heldInCash;
    this.containerId = this.option.id.toString();
    this.advisoryText = this.option.advisoryText;
    this.heldText = this.option.heldText;
    this.currentRate$ = this.questionnaire.bankRate.subscribe(value => {
      if (value) {
        const percent = this.percentPipe.transform(value, '1.0-3');
        this.description = this.option.description.replace('{}%', percent);
      }
    });
  }

  ngOnDestroy() {
    this.currentRate$.unsubscribe();
  }
}
